module.exports = __webpack_public_path__ + "static/img/icon_logo@2x.3a3f837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_logo@2x.png
// module id = T02M
// module chunks = 1